import React from 'react';
import { Box, Typography } from '@mui/material';
import { DASHBOARD_COLORS } from '../dashboardStyles';
import SalesOverviewPeriodToggle from './SalesOverviewPeriodToggle';
import InsightAiAssistantButton from '../ai/InsightAiAssistantButton';

const SalesOverviewHeader = ({
  period = 'monthly',
  onPeriodChange,
  compact = false,
  showPeriodToggle = true,
  showAiAssistant = false,
  onAiAssistantClick,
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 1,
      mb: compact ? 1 : 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: compact ? '0.8rem' : '1rem',
        color: DASHBOARD_COLORS.text,
      }}
    >
      Sales Overview
    </Typography>
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      {showAiAssistant && onAiAssistantClick && (
        <InsightAiAssistantButton onClick={onAiAssistantClick} />
      )}
      {showPeriodToggle && onPeriodChange && (
        <SalesOverviewPeriodToggle
          value={period}
          onChange={onPeriodChange}
          compact={compact}
        />
      )}
    </Box>
  </Box>
);

export default SalesOverviewHeader;
